var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[(_vm.reportData)?_c('b-col',{attrs:{"md":"12"}},[_c('training-list',{attrs:{"data":_vm.reportData,"title":"Eğitim Listesi"}})],1):_vm._e()],1),_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }